import { useState } from "react";
import { useBiLogger } from "../../../bi/useBiLogger";
import { PAGE_AREA } from "../../../bi/constants";

interface UseRecreateModalProps {
  onGenerate: (url: string) => void;
  onClose: () => void;
  validateUrl: (url: string) => boolean;
  errorMessage: string;
  pageArea: PAGE_AREA;
}

export const useRecreateModal = ({
  onGenerate,
  onClose,
  validateUrl,
  errorMessage,
  pageArea,
}: UseRecreateModalProps) => {
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [url, setUrl] = useState<string>("");
  const [urlError, setUrlError] = useState<string | undefined>(undefined);
  const biLogger = useBiLogger();

  const handleGenerateSite = () => {
    if (isGenerating) return;

    if (!validateUrl(url)) {
      biLogger.handleError({
        additionalInfo: pageArea,
        errorDesc: "Invalid URL",
        errorMessage,
      });
      setUrlError(errorMessage);
      return;
    }

    setUrlError(undefined);
    setIsGenerating(true);
    onGenerate(url);
  };

  const handleCancel = () => {
    if (isGenerating) return;

    setUrl("");
    setUrlError(undefined);
    setIsGenerating(false);
    onClose();
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (validateUrl(e.target.value)) {
      setUrlError(undefined);
    }
    setUrl(e.target.value);
  };

  return {
    isGenerating,
    url,
    urlError,
    handleGenerateSite,
    handleCancel,
    handleUrlChange,
  };
};
